module.exports = __webpack_public_path__ + "images/vkb_bc_avatar.png?97fbd69cd9dece79ae194dbc748ad135";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/vkb_bc_avatar.png
// module id = 2U/U
// module chunks = 0